import { render, staticRenderFns } from "./BrandFilter.vue?vue&type=template&id=485fa214&scoped=true"
import script from "./BrandFilter.vue?vue&type=script&lang=ts"
export * from "./BrandFilter.vue?vue&type=script&lang=ts"
import style0 from "./BrandFilter.vue?vue&type=style&index=0&id=485fa214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485fa214",
  null
  
)

export default component.exports